module.exports = __webpack_public_path__ + "static/media/publish-videos-images-tabletPro-en.5ed3f599.webp";